import { createReducer } from '@reduxjs/toolkit';
import { surveyReminderActions } from '~/behaviors/actions/survey_reminder.actions';
import { metaActions } from '~/behaviors/actions/meta.actions';

const defaultState = {};

const reset = () => defaultState;

const mergeSurveyReminders = (state, action) => {
  const surveyReminders = action?.payload?.entities.surveyReminders || {};

  Object.values(surveyReminders).forEach((reminder) => {
    // @ts-expect-error TS(2571): Object is of type 'unknown'.
    state[reminder.id] = {
      // @ts-expect-error TS(2571): Object is of type 'unknown'.
      ...state[reminder.id],
      // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
      ...reminder,
    };
  });
};

const deleteSurveyReminder = (state, action) => {
  const id = action?.payload?.id;
  if (state[id]) {
    delete state[id];
  }
};

const surveyReminders = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);

  builder.addCase(surveyReminderActions.findSurveyRemindersBySurveyId.fulfilled, mergeSurveyReminders);

  builder.addCase(surveyReminderActions.upsertReminder.fulfilled, mergeSurveyReminders);
  builder.addCase(surveyReminderActions.deleteReminder.fulfilled, deleteSurveyReminder);
});

export default surveyReminders;
